import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const BG = "#55765D";
const INK = "#FFFFFF";

const ITEMS = [
  { label: "Chillas", italic: false },
  { label: "Breakfast Mixes", italic: false },
  { label: "Pastas", italic: false },
  { label: "Noodles", italic: false },
  { label: "Pancakes", italic: false },
  { label: "& many more", italic: true },
];

export default function PillStrip() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.6 });

  return (
    <section
      data-testid="pill-strip"
      className="w-full py-5 sm:py-6"
      style={{ backgroundColor: BG }}
    >
      <div
        ref={ref}
        className="flex flex-wrap items-center justify-center gap-y-1"
        style={{ paddingLeft: "1.5rem", paddingRight: "1.5rem" }}
      >
        {ITEMS.map((item, i) => (
          <motion.span
            key={item.label}
            data-testid={`category-item-${i}`}
            initial={{ opacity: 0, y: 6 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.35, delay: i * 0.8, ease: "easeOut" }}
            className="flex items-center"
          >
            <span
              style={{
                fontFamily: "'Playfair Display', serif",
                fontWeight: item.italic ? 400 : 700,
                fontStyle: item.italic ? "italic" : "normal",
                fontSize: "clamp(0.95rem, 1.8vw, 1.35rem)",
                color: INK,
                whiteSpace: "nowrap",
              }}
            >
              {item.label}
            </span>
            {i < ITEMS.length - 1 && (
              <span
                style={{
                  color: INK,
                  opacity: 0.35,
                  fontSize: "clamp(0.7rem, 1vw, 0.9rem)",
                  margin: "0 0.9rem",
                }}
              >
                ·
              </span>
            )}
          </motion.span>
        ))}
      </div>
    </section>
  );
}
